export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
